package one.healthium.insights.data

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import one.healthium.db.ShoppingListDataEntity
import one.healthium.db.dao.ShoppingListDataDao
import one.healthium.insights.domain.shopping_list.ShoppingListDataModel
import one.healthium.insights.domain.shopping_list.ShoppingListDataRepository

class AppShoppingListDataRepository(
    private val shoppingListDataDao: ShoppingListDataDao,
) : ShoppingListDataRepository {
    override fun getShoppingListData(id: String): Flow<ShoppingListDataModel> {
        return shoppingListDataDao.getShoppingListData(id)
            .map { mapToModel(id, it) }
    }

    override suspend fun setShoppingListChecked(id: String, itemId: String, checked: Boolean) {
        shoppingListDataDao.setShoppingListChecked(id, itemId, checked)
    }

    private fun mapToModel(id: String, entities: List<ShoppingListDataEntity>): ShoppingListDataModel {
        return ShoppingListDataModel(
            id = id,
            checkedIds = entities.mapNotNull { if (it.checked == 1L) it.itemId else null }.toSet(),
        )
    }
}